"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var ManagerWithSession = /*#__PURE__*/function () {
  function ManagerWithSession(session) {
    (0, _classCallCheck2.default)(this, ManagerWithSession);
    this.session = session;
  }

  (0, _createClass2.default)(ManagerWithSession, [{
    key: "getSession",
    value: function getSession() {
      return this.session;
    }
  }, {
    key: "setSession",
    value: function setSession(session) {
      if (session && session !== this.session) {
        this.session = session;
      }
    }
  }]);
  return ManagerWithSession;
}();

exports.default = ManagerWithSession;
module.exports = exports.default;